/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_syl_per_line = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per line`)
};

const es_syl_per_line = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por línea`)
};

const de_syl_per_line = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro Zeile`)
};

const nl_syl_per_line = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per regel`)
};

const fr_syl_per_line = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Par ligne`)
};

const it_syl_per_line = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per riga`)
};

const pt_br2_syl_per_line = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por linha`)
};

const pt_syl_per_line = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por linha`)
};

const ja_syl_per_line = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`行ごと`)
};

const zh_syl_per_line = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每行`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const syl_per_line = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.syl_per_line(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("syl_per_line", locale)
	if (locale === "en") return en_syl_per_line(inputs)
	if (locale === "es") return es_syl_per_line(inputs)
	if (locale === "de") return de_syl_per_line(inputs)
	if (locale === "nl") return nl_syl_per_line(inputs)
	if (locale === "fr") return fr_syl_per_line(inputs)
	if (locale === "it") return it_syl_per_line(inputs)
	if (locale === "pt-BR") return pt_br2_syl_per_line(inputs)
	if (locale === "pt") return pt_syl_per_line(inputs)
	if (locale === "ja") return ja_syl_per_line(inputs)
	return zh_syl_per_line(inputs)
};